// PETROCONTROL - Servicios de gestión integral para el sector energético
// Enfocado en: Permisos de autoconsumo, controles volumétricos y suministro de combustible

const practiceAreaBase = [
  { id: "gestion-integral", icon: "Briefcase", attorney: "Equipo PETROCONTROL" },
  { id: "permisos-autoconsumo", icon: "FileText", attorney: "Equipo permisos" },
  { id: "controles-volumetricos", icon: "BarChart3", attorney: "Equipo técnico" },
  { id: "suministro-combustible", icon: "Truck", attorney: "Equipo comercial" },
];

const expertBase = [
  // Sección de equipo deshabilitada - sin fotos de personas
];

function mergePA(langItems) {
  return langItems.map((item, i) => ({ ...practiceAreaBase[i], ...item }));
}

function mergeExperts(langItems) {
  return langItems.map((item, i) => ({ ...expertBase[i], ...item }));
}

// ============================================================
// ESPAÑOL
// ============================================================
const es = {
  nav: { services: "Servicios", about: "Nosotros", team: "Equipo", results: "Resultados", contact: "Contacto", clientAccess: "Acceso clientes" },
  headerCta: "Diagnóstico gratuito",

  hero: {
    subtitle: "Desde el inicio de la Reforma Energética",
    headline: "Gestión de permisos de autoconsumo y cumplimiento regulatorio",
    description: "Servicio integral para empresas que requieren operar estaciones de combustible en sus instalaciones. Gestionamos permisos CNE, controles volumétricos SAT y suministro de combustible con comercializadores autorizados.",
    cta: "Solicitar diagnóstico gratuito",
  },

  about: {
    subtitle: "Conócenos",
    headline: "Tu aliado en regulación energética",
    desc1: "En PETROCONTROL nos especializamos en la gestión integral de permisos de autoconsumo para empresas que necesitan operar estaciones de combustible en sus instalaciones operativas. Somos expertos en trámites ante la CNE y cumplimiento de obligaciones regulatorias.",
    desc2: "Desde el inicio de la Reforma Energética hemos acompañado a empresas de diversos sectores industriales en la obtención de sus permisos, implementación de controles volumétricos y gestión de suministro de combustible con comercializadores autorizados.",
    cta: "Conocer más",
    stats: { casesWon: "Permisos tramitados", yearsExp: "Años de experiencia", clientsServed: "Clientes satisfechos" },
  },

  practiceAreas: {
    subtitle: "Nuestros servicios",
    headline: "Servicios especializados",
    description: "Soluciones integrales para empresas que requieren operar estaciones de combustible en sus instalaciones.",
    learnMore: "Ver más",
    items: mergePA([
      {
        title: "Gestión integral",
        shortDesc: "Servicio completo que incluye gestión de permisos de autoconsumo, seguimiento a reportes obligatorios CNE, controles volumétricos SAT y suministro de combustible.",
        fullDesc: "Nuestro servicio de gestión integral está diseñado para empresas que requieren una solución completa. Nos encargamos de todo el proceso: desde la obtención del permiso de autoconsumo ante la CNE, hasta la implementación de controles volumétricos, el cumplimiento de reportes obligatorios y la conexión con comercializadores autorizados para el suministro de combustible.",
        cases: ["Gestión de permiso de autoconsumo CNE", "Seguimiento a reportes obligatorios CNE", "Implementación de controles volumétricos SAT", "Coordinación de suministro de combustible", "Cumplimiento de obligaciones regulatorias", "Asesoría continua y soporte", "Representación ante autoridades", "Auditorías de cumplimiento"],
        faq: [
          { q: "¿Qué incluye el servicio de gestión integral?", a: "Incluye todo lo necesario para operar legalmente: obtención de permiso de autoconsumo, implementación de controles volumétricos, cumplimiento de reportes CNE y coordinación de suministro con comercializadores autorizados." },
          { q: "¿Cuánto tiempo toma implementar todo el servicio?", a: "El tiempo varía según la complejidad, pero generalmente entre 3 a 6 meses para tener todo operando. Trabajamos en paralelo para optimizar tiempos." },
          { q: "¿Qué ventajas tiene contratar el servicio integral?", a: "Tienes un solo proveedor para todas tus necesidades regulatorias, lo que simplifica la gestión, reduce costos y asegura que todo esté coordinado correctamente." },
          { q: "¿Incluye el suministro de combustible?", a: "Coordinamos con comercializadores autorizados por la CNE para asegurar tu suministro de combustible de manera legal y competitiva." },
        ],
      },
      {
        title: "Permisos de autoconsumo",
        shortDesc: "Gestión especializada de permisos CNE para empresas que necesitan operar estaciones de combustible en sus instalaciones operativas.",
        fullDesc: "El permiso de autoconsumo es indispensable para cualquier empresa que requiera almacenar y despachar combustible en sus propias instalaciones. Gestionamos todo el proceso ante la CNE, desde la preparación de documentación hasta la obtención del permiso y el seguimiento de reportes obligatorios.",
        cases: ["Permisos de autoconsumo de diésel", "Permisos de autoconsumo de gasolina", "Regularización de instalaciones existentes", "Modificación de permisos vigentes", "Renovación de permisos", "Seguimiento a reportes obligatorios CNE", "Cumplimiento de condiciones del permiso", "Representación ante inspecciones"],
        faq: [
          { q: "¿Qué empresas necesitan permiso de autoconsumo?", a: "Cualquier empresa que almacene combustible para uso propio: industria manufacturera, transporte, agricultura, minería, construcción, entre otras." },
          { q: "¿Qué requisitos pide la CNE para el permiso?", a: "Acta constitutiva, RFC, documentación de las instalaciones, planos, medidas de seguridad, entre otros. Te guiamos en cada requisito." },
          { q: "¿Cuánto tarda obtener el permiso?", a: "El tiempo promedio es de 3 a 4 meses, dependiendo de la complejidad y si la documentación está completa." },
          { q: "¿Qué pasa si ya opero sin permiso?", a: "Podemos ayudarte a regularizar tu situación. Es importante actuar pronto para evitar sanciones de las autoridades." },
        ],
      },
      {
        title: "Controles volumétricos",
        shortDesc: "Implementación y certificación de sistemas de medición para cumplimiento de obligaciones fiscales ante el SAT.",
        fullDesc: "Los controles volumétricos son obligatorios para todos los permisionarios de hidrocarburos. Implementamos sistemas de medición certificados que cumplen con los lineamientos del SAT, garantizando el reporte preciso de tus operaciones y evitando sanciones.",
        cases: ["Implementación de sistemas de medición", "Certificación de equipos volumétricos", "Generación de reportes mensuales al SAT", "Auditorías de cumplimiento", "Integración con sistemas existentes", "Capacitación al personal operativo", "Soporte técnico continuo", "Actualización ante cambios normativos"],
        faq: [
          { q: "¿Es obligatorio tener controles volumétricos?", a: "Sí, desde 2018 es obligatorio para todos los permisionarios de hidrocarburos reportar al SAT mediante sistemas de controles volumétricos certificados." },
          { q: "¿Qué sanciones hay por incumplimiento?", a: "Las multas son muy elevadas y pueden incluir la suspensión del permiso. Es fundamental mantener el cumplimiento al día." },
          { q: "¿Cada cuánto debo reportar al SAT?", a: "Los reportes son mensuales y deben enviarse dentro de los primeros 10 días del mes siguiente." },
          { q: "¿Qué equipo necesito instalar?", a: "Depende del volumen y tipo de operación. Realizamos un diagnóstico para recomendarte la mejor solución." },
        ],
      },
      {
        title: "Suministro de combustible",
        shortDesc: "Conexión con comercializadores autorizados por la CNE para garantizar el suministro legal y competitivo de combustible.",
        fullDesc: "Una vez que tienes tu permiso de autoconsumo, necesitas un proveedor de combustible autorizado. Te conectamos con comercializadores que cuentan con todos los permisos de la CNE, asegurando un suministro legal, de calidad y a precios competitivos.",
        cases: ["Conexión con comercializadores autorizados CNE", "Negociación de contratos de suministro", "Verificación de permisos de proveedores", "Logística de entrega", "Facturación electrónica conforme", "Precios competitivos", "Suministro de diésel", "Suministro de gasolina"],
        faq: [
          { q: "¿Por qué necesito un comercializador autorizado?", a: "Por ley, solo puedes comprar combustible a comercializadores con permiso vigente de la CNE. Comprar a proveedores no autorizados es ilegal." },
          { q: "¿Cómo verifico que un proveedor esté autorizado?", a: "Nosotros verificamos los permisos de todos los comercializadores con los que trabajamos y te proporcionamos la documentación de respaldo." },
          { q: "¿Pueden conseguirme mejores precios?", a: "Al trabajar con varios comercializadores, podemos negociar condiciones competitivas para tu empresa." },
          { q: "¿Qué tipos de combustible manejan?", a: "Principalmente diésel y gasolinas. Trabajamos con comercializadores que manejan todo tipo de petrolíferos." },
        ],
      },
    ]),
  },

  practiceDetails: {
    subtitle: "Detalle del servicio",
    headline: "Cómo podemos ayudarte",
    commonCases: "Servicios que incluye",
    faqTitle: "Preguntas frecuentes",
    getHelp: "Solicitar información",
    yearsExp: "años de experiencia",
  },

  attorneys: {
    subtitle: "Nuestro equipo",
    headline: "Expertos a tu servicio",
    description: "Contamos con un equipo especializado en regulación energética con amplia experiencia desde el inicio de la Reforma Energética.",
    items: mergeExperts([
      { title: "Director de operaciones", practiceAreas: ["Permisos CNE", "Gestión integral"], awards: ["Certificación CRE", "Especialista CNE"] },
      { title: "Directora legal", practiceAreas: ["Regulación energética", "Permisos de autoconsumo"], awards: ["Especialista en derecho energético"] },
      { title: "Director técnico", practiceAreas: ["Controles volumétricos", "Sistemas de medición"], awards: ["Especialista SAT", "Certificación ISO 9001"] },
    ]),
  },

  caseResults: {
    subtitle: "Casos de éxito",
    headline: "Resultados que hablan por sí mismos",
    disclaimer: "*Cada caso es único y los resultados dependen de las circunstancias específicas de cada cliente.",
    metrics: [
      { label: "Permisos aprobados" },
      { label: "Empresas regularizadas" },
      { label: "Tasa de éxito" },
    ],
    items: [
      { type: "Permiso de autoconsumo", amount: "Aprobado", challenge: "Empresa de transporte con 50 unidades que necesitaba operar su propia estación de diésel en sus instalaciones.", outcome: "Permiso de autoconsumo obtenido en 3 meses, incluyendo controles volumétricos y contrato de suministro." },
      { type: "Gestión integral", amount: "100% cumplimiento", challenge: "Grupo industrial con 3 plantas que operaban sin permisos y con proveedores no autorizados.", outcome: "Regularización completa: permisos de autoconsumo, controles volumétricos y conexión con comercializadores autorizados." },
      { type: "Controles volumétricos", amount: "Implementado", challenge: "Empresa agrícola con múltiples tanques de almacenamiento sin sistema de medición certificado.", outcome: "Implementación de controles volumétricos en 30 días, evitando sanciones del SAT." },
    ],
  },

  testimonials: {
    subtitle: "Testimonios",
    headline: "Lo que dicen nuestros clientes",
    items: [
      { name: "Transportes del Norte S.A.", caseType: "Permiso de autoconsumo", rating: 5, quote: "PETROCONTROL nos ayudó a obtener nuestro permiso de autoconsumo y ahora operamos nuestra estación de diésel de manera legal y eficiente." },
      { name: "Industrias Manufactureras", caseType: "Gestión integral", rating: 5, quote: "Contratamos el servicio integral y nos olvidamos de preocupaciones. Ellos se encargan de todo: permisos, reportes y suministro." },
      { name: "Agroindustrias del Bajío", caseType: "Controles volumétricos", rating: 5, quote: "Implementaron nuestros controles volumétricos en tiempo récord. Ahora cumplimos con el SAT sin complicaciones." },
      { name: "Constructora Nacional", caseType: "Suministro de combustible", rating: 5, quote: "Nos conectaron con un comercializador autorizado y conseguimos mejores precios de los que teníamos antes." },
    ],
  },

  fees: {
    subtitle: "Modalidades de servicio",
    headline: "Opciones flexibles para tu empresa",
    description: "Ofrecemos diferentes modalidades para adaptarnos a las necesidades de cada cliente.",
    items: [
      { title: "Diagnóstico gratuito", subtitle: "Sin compromiso", description: "Evaluamos tu situación regulatoria sin costo para determinar qué necesitas.", list: ["Análisis de situación actual", "Identificación de permisos requeridos", "Estimación de tiempos y costos", "Recomendaciones personalizadas", "Respuesta en 24-48 horas"], highlight: true },
      { title: "Proyecto específico", subtitle: "Precio fijo", description: "Precio cerrado por servicio específico: permiso, controles o suministro.", list: ["Un solo servicio", "Precio definido desde el inicio", "Sin sorpresas", "Entregables claros", "Soporte durante el proceso"], highlight: false },
      { title: "Gestión integral", subtitle: "Todo incluido", description: "Servicio completo: permisos, controles volumétricos, reportes y suministro.", list: ["Todos los servicios incluidos", "Un solo proveedor", "Asesoría continua", "Cumplimiento garantizado", "Mejor relación costo-beneficio"], highlight: false },
    ],
    freeConsult: { title: "Diagnóstico gratuito", desc: "Comienza con una evaluación sin costo de tu situación regulatoria. Sin compromiso.", note: "Contáctanos para agendar tu diagnóstico gratuito." },
  },

  consultation: {
    heading: "Solicita tu diagnóstico gratuito",
    description: "Completa el formulario y un especialista te contactará en menos de 24 horas.",
    openingHoursTitle: "Horario de atención",
    weekdays: "Lunes - Viernes: 9:00 AM - 6:00 PM",
    saturday: "Sábado: 10:00 AM - 2:00 PM",
    labels: { firstName: "Nombre", lastName: "Apellido", email: "Correo electrónico", phone: "Teléfono", describe: "Describe tu situación" },
    placeholders: { firstName: "Tu nombre", lastName: "Tu apellido", email: "correo@empresa.com", phone: "+52 (55) 1234-5678", describe: "Cuéntanos sobre tu empresa y qué necesitas..." },
    submitBtn: "Solicitar diagnóstico",
    sending: "Enviando...",
    successMsg: "¡Gracias! Un especialista te contactará dentro de las próximas 24 horas.",
    errorMsg: "Ocurrió un error. Por favor intenta de nuevo o llámanos directamente.",
    requiredMsg: "Por favor completa todos los campos requeridos.",
  },

  faq: {
    subtitle: "Preguntas frecuentes",
    headline: "Resolvemos tus dudas",
    noAnswer: { title: "¿No encontraste tu respuesta?", desc: "Nuestro equipo está listo para resolver cualquier duda específica.", cta: "Contáctanos directamente" },
  },

  contact: {
    subtitle: "Contacto",
    headline: "Estamos para ayudarte",
    description: "Contáctanos por cualquiera de nuestros canales. Estamos listos para atenderte.",
    officeAddress: "Dirección",
    phone: "Teléfono",
    whatsapp: "WhatsApp",
    whatsappCta: "Enviar mensaje",
    emailLabel: "Correo Electrónico",
    officeHours: "Horario de Atención",
    languages: "Idiomas",
    langList: ["Español", "Inglés"],
  },

  ctaBanner: {
    headline: "¿Necesitas operar tu propia estación de combustible?",
    description: "Te ayudamos con todo: permisos de autoconsumo, controles volumétricos y suministro de combustible. Solicita tu diagnóstico gratuito.",
    cta: "Solicitar diagnóstico gratuito",
  },

  footer: {
    cta: "Diagnóstico gratuito",
    contactTitle: "Contacto",
    menuTitle: "Menú",
    practiceAreasTitle: "Servicios",
    copyright: "© {year} PETROCONTROL. Todos los derechos reservados.",
    disclaimer: "Servicios de gestión regulatoria para el sector energético. La información en este sitio es solo para fines informativos.",
  },

  booking: {
    title: "Solicita tu diagnóstico gratuito",
    description: "Completa el formulario y un especialista analizará tu caso sin costo ni compromiso.",
    caseType: "Servicio de interés",
    caseTypePlaceholder: "Selecciona el servicio que necesitas",
    caseDescription: "Describe tu situación",
    caseDescPlaceholder: "Cuéntanos sobre tu empresa: ¿qué tipo de operación tienes? ¿necesitas almacenar combustible? ¿tienes tanques instalados?...",
    contactMethod: "Método de contacto preferido",
    contactMethodPlaceholder: "¿Cómo prefieres que te contactemos?",
    fullName: "Nombre completo",
    phonePlaceholder: "+52 (55) 1234-5678",
    emailPlaceholder: "correo@empresa.com",
    preferredDate: "Fecha preferida",
    pickDate: "Selecciona fecha",
    preferredTime: "Horario preferido",
    selectTime: "Selecciona horario",
    selectedAttorney: "Especialista asignado",
    privacyText: "Acepto la política de privacidad y autorizo a PETROCONTROL a contactarme respecto a mi solicitud. Toda la información compartida es confidencial.",
    submitBtn: "Solicitar diagnóstico gratuito",
    submitting: "Enviando...",
    confidentialNote: "Tu información está protegida y es completamente confidencial",
    contactMethods: ["Teléfono", "Correo", "WhatsApp"],
    errors: { caseType: "Selecciona un servicio", description: "Describe tu situación", contactMethod: "Selecciona un método de contacto", fullName: "Nombre completo requerido", phone: "Teléfono requerido", email: "Email válido requerido", date: "Selecciona una fecha", time: "Selecciona un horario", privacy: "Debes aceptar la política de privacidad" },
  },

  servicePage: {
    backHome: "Volver al inicio",
    casesTitle: "Servicios que incluye",
    faqTitle: "Preguntas frecuentes",
    leadAttorney: "Especialista responsable",
    yearsExp: "años de experiencia",
    scheduleCta: "Solicitar información",
    relatedServices: "Servicios relacionados",
    ctaHeadline: "¿Necesitas ayuda con {service}?",
    ctaDesc: "Nuestros especialistas están listos para ayudarte. Solicita tu diagnóstico gratuito hoy.",
    ctaBtn: "Solicitar diagnóstico gratuito",
  },

  trustStats: [
    { value: "120+", label: "Permisos tramitados" },
    { value: "7", label: "Años de experiencia" },
    { value: "120+", label: "Clientes satisfechos" },
    { value: "98%", label: "Tasa de éxito" },
  ],

  clientPortal: {
    title: "Acceso clientes",
    subtitle: "Ingresa a tu portal para dar seguimiento a tus trámites",
    loginTitle: "Iniciar sesión",
    email: "Correo electrónico",
    password: "Contraseña",
    loginBtn: "Ingresar",
    forgotPassword: "¿Olvidaste tu contraseña?",
    noAccount: "Si aún no tienes cuenta, contacta a tu ejecutivo asignado.",
    dashboard: {
      welcome: "Bienvenido",
      activeTramites: "Trámites activos",
      documents: "Documentos",
      uploadDocument: "Subir documento",
      viewAll: "Ver todos",
      status: "Estatus",
      lastUpdate: "Última actualización",
      noTramites: "No tienes trámites activos",
      tramiteDetails: "Detalles del trámite",
    },
  },
};

// Solo exportamos español
const en = es;
const fr = es;
const de = es;
const zh = es;

const translations = { en, es, fr, de, zh };
export default translations;
